import gql from 'graphql-tag';

export const repositoriesDependenciesVulnerabilitiesQuery = gql`
  query RepositoriesDependenciesVulnerabilities(
    $input: VulnerabilitiesDependenciesInput!
  ) {
    repositoriesDependenciesVulnerabilities(input: $input) {
      repositoryId
      repositoryName
      dependencyTree {
        childDependencyIds
        dependencyId
        dependencyName
        dependencyVersion
        issueHighCount
        issueHighIds
        issueLowCount
        issueLowIds
        issueMediumCount
        issueMediumIds
        licenses
        nodeId
        packageManager
        rootDependency
        dependencies {
          childDependencyIds
          dependencyId
          dependencyName
          dependencyVersion
          issueHighCount
          issueHighIds
          issueLowCount
          issueLowIds
          issueMediumCount
          issueMediumIds
          licenses
          nodeId
          packageManager
          rootDependency
        }
      }
    }
  }
`;
